module.exports = __webpack_public_path__ + "static/mo33-9e2d8ce89a9dc2a8fd630bf13b9e3201.png";